import React from 'react';
import { StyledCarouselContainer, StyledGridItemWrapper } from '../style/CarouselSkeletonV3.styles';
import ProductCardSkeletonV3 from './ProductCardSkeletonV3';

interface ProductCarouselSkeletonProps {
  count?: number;
  isHorizontal?: boolean;
}

const CarouselSkeletonV3: React.FC<ProductCarouselSkeletonProps> = ({ count = 9, isHorizontal = false }) => {
  return (
    <StyledCarouselContainer isHorizontal={isHorizontal}>
      {Array.from({ length: count }).map((_, index) => (
        <StyledGridItemWrapper key={index} isHorizontal={isHorizontal}>
          <ProductCardSkeletonV3 />
        </StyledGridItemWrapper>
      ))}
    </StyledCarouselContainer>
  );
};

export default CarouselSkeletonV3;
